<template>
  <div class="table-links">
    <heading :title="title" level="h2" />
    <accordions v-for="(group, index) in link_group" :key="`accordions_${index}`">
      <heading v-if="group.title" :title="group.title" level="h3" />
      <accordion
        v-for="(item, index) in group.links"
        :key="`accordion_${index}`"
        v-bind="item"
      />
    </accordions>
    <Button v-for="(button, i) in buttons" :key="`button_${i}`" class="button--margin" v-bind="button" />
  </div>
</template>

<script>
import Heading from '@/components/heading/Heading.vue'
import Accordions from '@/sections/accordions/Accordions'
import Accordion from '@/components/partials/Accordion'
import Button from '@/components/partials/Button'

export default {
  name: 'SectionTablelinks',
  components: {
    Heading,
    Accordions,
    Accordion,
    Button
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    link_group: {
      type: Array,
      default: () => []
    },
    buttons: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.accordions {
  & + .button {
    margin-top: rem(40);
  }
}
</style>
